const getOverriddenItems = (state: AnyFixMe) => state.wixCodeIDE.overridden;

export { getOverriddenItems };
